import React, { useState, useEffect } from 'react'
import FormikControl from '../../hoc/formikComponents/FormikControl'
import { Formik, Form, Field, FieldArray } from 'formik';
import Fetcher from '../../hoc/FetcherSetting/FetcherSetting';
import { useMutation, useQuery } from 'react-query';
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance';
import axios from 'axios';
import { APIURL } from '../../hoc/AxiosSetting/axios';
export default function EditAccess() {

    const [initialValues, setInitialValues] = useState({
        orgCode: 0,
        orgName: "",
        typeOfCertification: "",
        managerName: "",
        managerCode: "",
        executiveSupport: {
            userCode: 0,
            userName: "",
            designation:""
        
        },
        leadAuditor: {
            userCode: 0,
            userName: "",
            designation:""
        },
        assitAuditor: {
            userCode: 0,
            userName: "",
            designation:""
        },
        client: {
            userCode: 0,
            userName: "",
            designation:""
        },
        auditor: {
            userCode: 0,
            userName: "",
            designation:""
        },
    })
    const [leadauditorList, setLeadauditorList] = useState([{
        label: "",
        value: ""
    }]);
    const [assitAuditorList, setassitAuditorList] = useState([{
        label: "",
        value: ""
    }])
    const [auditorList, setauditorList] = useState([{
        label: "",
        value: ""
    }])
    const [ExecutiveList, setExecutiveList] = useState([{
        label: "",
        value: ""
    }])
    const { data: orgList, isLoading: orgLoading } = useQuery(
        'listOrg',
        () => Fetcher('get', '/api/rfq/get/listofcompanies', {}))

    const { data: ManagerList, isLoading: ManagerLoading } = useQuery(
        'listManager',
        () => Fetcher('get', '/api/profile/get/keyvalueformanager', {}))


    const { data: clientList, isLoading: clientLoading } = useQuery(
        'listclient',
        () => Fetcher('get', '/api/profile/get/keyvalueforclient', {}))


    const mutationExecutive = useMutation((params) => Fetcher('get', '/api/profile/get/keyvaluelistexcutive/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("keyvaluelistexcutive", data.data.response)
                setExecutiveList(data.data.response)

            } else {
                var msg = 'Executive List - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Executive Support' + error)
        }
    })
    const mutation = useMutation((params) => Fetcher('patch', '/api/clientaccess/patch/addclientaccessdata', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Client Access Data Added')
            }
            else {
                var msg = 'Client Access - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Client Access' + error)
        }
    })
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        console.log("values", values)
        mutation.mutate(values)
    }
    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/clientaccess/get/clientaccessdetailsbyorgcode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                console.log("tempInitialValues",data.data.response)
                
                // tempInitialValues.executiveSupport ={
                //                      userCode : data.data.response.executiveSupport.userCode,
                //                      userName : data.data.response.executiveSupport.userName
                // }
                // tempInitialValues.client ={
                //     userCode : data.data.response.client.userCode,
                //     userName : data.data.response.client.userName
                // }
                // tempInitialValues.leadAuditor ={
                //     userCode : data.data.response.leadAuditor.userCode,
                //     userName : data.data.response.leadAuditor.userName
                // }
                // tempInitialValues.auditor ={
                //     userCode : data.data.response.auditor.userCode,
                //     userName : data.data.response.auditor.userName
                // }
                // tempInitialValues.assitAuditor ={
                //     userCode : data.data.response.assitAuditor.userCode,
                //     userName : data.data.response.assitAuditor.userName
                // }
                if(tempInitialValues.executiveSupport.userCode)
                {
                    mutationExecutive.mutate(tempInitialValues.managerCode)
                    tempInitialValues.executiveSupport ={
                        userCode : data.data.response.executiveSupport.userCode,
                        userName : data.data.response.executiveSupport.userName
                }
                }
                if(!tempInitialValues.executiveSupport.userCode){
                    mutationExecutive.mutate(tempInitialValues.managerCode)
                }
               
                        setInitialValues(tempInitialValues)
                        console.log("initialvalues",initialValues)
                }
        },
        onError(error) {
            console.error('Got error from backend', error.message)
        }
    })
    if (orgLoading || ManagerLoading || clientLoading) return <h1>Loading</h1>
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                // validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {
                    formik =>
                        <Form>
                            <div classname="content-wrapper">
                                <section classname="content">
                                    <div classname="container-fluid">
                                        <div classname="row">
                                            <div className="col-sm-12">

                                                <div className="formOuterDiv">
                                                    <div className="form2RowDiv">
                                                        <FormikControl control='selectNACECode' label='Org Name' name='orgCode' options={orgList.data.response}
                                                            onChange={
                                                                (e) => {
                                                                    mutationgetCompanyDetails.mutate(e.value);
                                                                    formik.setFieldValue(`orgCode`, e.value)
                                                                    formik.setFieldValue(`orgName`, e.label)
                                                                    formik.setFieldValue(`typeOfCertification`,e.typeOfCertification)
                                                                    
                                                                    if(e.nabcbcode){
                                                                       
                                                                        axios.get(APIURL + '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + e.nabcbcode)
                                                                        .then(data=>{
                                                                          
                                                                            setLeadauditorList(data.data.response)
                                                                        })
                                                                        axios.get(APIURL + '/api/profile/get/keyvalueforAssistAuditorCommonNacecode/' + e.nabcbcode)
                                                                        .then(data=>{
                                                                         
                                                                            setassitAuditorList(data.data.response)
                                                                        })
                                                                        axios.get(APIURL + '/api/profile/get/keyvalueforAuditorCommonNacecode/' + e.nabcbcode)
                                                                        .then(data=>{
                                                                         
                                                                            setauditorList(data.data.response)
                                                                        })
                                                                       

                                                                    }

                                                                }
                                                            }
                                                        />
                                                        <FormikControl control='input' label='Type of Certification' name='typeOfCertification' />
                                                    </div>
                                                    <div className='form2RowDiv'>
                                                        <FormikControl control='selectNACECode' options={ManagerList.data.response} name='managerCode' label='Manger'
                                                            onChange={
                                                                (e) => {
                                                                    formik.setFieldValue(`managerCode`, e.value)
                                                                    formik.setFieldValue(`managerName`, e.label)
                                                                   



                                                                }
                                                            } />

                                                        <FormikControl control='selectNACECode' options={ExecutiveList} name="executiveSupport.userCode" label='Executive Support'  
                                                         onChange={
                                                            (e) => {
                                                                console.log("e",e)   
                                                                console.log("initial")
                                                                formik.setFieldValue(`executiveSupport`, e  )
                                                            }
                                                        }
                                                         />

                                                    </div>
                                                    <div className='form2RowDiv'>
                                                        <FormikControl control="selectNACECode" name="leadAuditor.userCode" options={leadauditorList} label='Lead Auditor'
                                                            onChange={
                                                                (e) => {
                                                                 
                                                                    formik.setFieldValue(`leadAuditor`, e  )
                                                                    
                                                                }
                                                            }
                                                         
                                                        />
                                                           <FormikControl control="selectNACECode" name="auditor.userCode" options={auditorList} label='Auditor'
                                                            onChange={
                                                                (e) => {
                                                                    
                                                                    formik.setFieldValue(`auditor`, e)
                                                                 
                                                              

                                                                }
                                                            }
                                                            
                                                        />
                                                    </div>
                                                     
                                                   
                                                    <div className='form2RowDiv'>
                                                    <FormikControl control="selectNACECode" name="assitAuditor.userCode" options={assitAuditorList} label='Assistant Auditor'
                                                            onChange={
                                                                (e) => {
                                                                    formik.setFieldValue(`assitAuditor`, e)
                                                                }
                                                            }
                                                            
                                                        />
                                                        <FormikControl control="selectNACECode" name="client.userCode" options={clientList.data.response} label='Client'
                                                            onChange={
                                                                (e) => {
                                                                    formik.setFieldValue(`client`, e)

                                                                }
                                                            }
                                                        />
                                                    </div>









                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-lg-10"></div>
                                    <div className="col-lg-2">
                                        <button type="submit" className="btn btn-primary" >Submit</button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                }

            </Formik>
        </div>

    )
}
